import { render, staticRenderFns } from "./fivePart.vue?vue&type=template&id=a79eeb8a&scoped=true&"
import script from "./fivePart.vue?vue&type=script&lang=js&"
export * from "./fivePart.vue?vue&type=script&lang=js&"
import style0 from "./fivePart.vue?vue&type=style&index=0&id=a79eeb8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79eeb8a",
  null
  
)

export default component.exports